import { styled, TypographyProps } from '@mui/material';
import { HTMLAttributeAnchorTarget } from 'react';
import { Link } from 'react-router-dom';
import { Text } from './view.box';

const StyledLink = styled(Link, { shouldForwardProp: prop => prop !== 'disabled' })<{ disabled?: boolean }>(
	({ disabled }) => ({
		color: 'inherit',
		pointerEvents: disabled ? 'none' : 'auto',
		textDecoration: disabled ? 'none' : 'underline',
	}),
);

export function LinkView({
	to,
	target,
	disabled,
	...props
}: TypographyProps & { to: string; target?: HTMLAttributeAnchorTarget; disabled?: boolean }) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.stopPropagation();
		if (disabled) e.preventDefault();
	};
	return (
		<StyledLink to={to} target={target} onClick={handleClick} disabled={disabled}>
			<Text noWrap variant="body2" {...props}></Text>
		</StyledLink>
	);
}
